export default (axios, type) => axios.get(`/report/templates/?type=${type}`);
